import PropTypes from 'prop-types';
import { AlertCircle, FileText, Users, Search } from 'lucide-react';

const iconMap = {
  surveys: FileText,
  users: Users,
  search: Search,
  error: AlertCircle,
};

function EmptyState({
  icon = 'search',
  title = 'Aucun résultat',
  description = 'Aucune donnée disponible pour le moment.',
  action = null,
  className = '',
}) {
  const Icon = iconMap[icon] || iconMap.search;

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`}>
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="font-display text-lg font-semibold text-foreground mb-2">{title}</h3>
       <p className="text-sm text-muted-foreground text-center max-w-sm mb-6">{description}</p>
      {/*{action && (
        <Button onClick={action.onClick} className="gap-2">
          <Plus className="h-4 w-4" />
          {action.label}
        </Button>
      )} */}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.oneOf(['surveys', 'users', 'search', 'error']),
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.shape({
    onClick: PropTypes.func,
    label: PropTypes.string,
  }),
  className: PropTypes.string,
};

EmptyState.defaultProps = {
  icon: 'search',
  title: 'Aucun résultat',
  description: 'Aucune donnée disponible pour le moment.',
  action: null,
  className: '',
};

export default EmptyState;
